import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useToastContext } from "components/alert/ToastContext";
import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Atividade from "model/gestao/atividades/Atividade";
import AtividadeApontamento from "model/gestao/atividades/AtividadeApontamento";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useRef, useState } from "react";
import AtividadeApontamentoService from "service/gestao/atividades/AtividadeApontamentoService";
import AtividadeMeusApontamentosService from "service/gestao/atividades/AtividadeMeusApontamentosService";
import { converterDataHora } from "utils/convert";
import { DateMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, IdMatchModeOptions } from "utils/filterUtils";
import AtividadeApontamentoCadastro from "./AtividadeApontamentoCadastro";

const atividadeMeusApontamentosService = new AtividadeMeusApontamentosService();
const atividadeApontamentoService = new AtividadeApontamentoService();
export default function AtividadeMeusApontamentosListagem() {
    const [atividades, setAtividades] = useState<Atividade[]>([]);
    const [pessoas, setPessoas] = useState<Pessoa[]>([]);
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();
    const { startLoading, stopLoading } = useLoadingContext();
    const [atividadeApontamentoModal, setAtividadeApontamentoModal] = useState<{ visible: boolean, idAtividadeApontamento?: number }>({ visible: false });
    const listagemRef = useRef<BaseListagemRef>(null);


    const defaultFilters: DataTableFilterMeta = {
        dataInicio: {
            constraints: [
                {
                    value: "",
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        dataFim: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        pessoa: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        atividade: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);


    useEffect(() => {
        atividadeApontamentoService.atividades().then(response => setAtividades(response)).catch(() => setAtividades([]));
        atividadeApontamentoService.clientes().then(response => setPessoas(response)).catch(() => setPessoas([]));
    }, []);


    function getButtonsExtra() {
        return [
            <Button
                type="button"
                icon="pi pi-plus"
                onClick={() => novoApontamento()}
            />,
        ]
    }

    function novoApontamento() {
        setAtividadeApontamentoModal({ visible: true });
    }

    function editarApontamento(item: AtividadeApontamento) {
        setAtividadeApontamentoModal({ visible: true, idAtividadeApontamento: item.id });
    }

    return (
        <>
            {atividadeApontamentoModal ? <Dialog visible={atividadeApontamentoModal.visible} baseZIndex={100} style={{ width: '65vw', minHeight: "50vh" }} modal onHide={() => setAtividadeApontamentoModal({ visible: false, idAtividadeApontamento: undefined })}
                header="Apontamento de Atividade">
                <AtividadeApontamentoCadastro isModal={true} onSave={() => {
                    setAtividadeApontamentoModal({ visible: false, idAtividadeApontamento: undefined });
                    listagemRef.current?.reload();
                }} id={atividadeApontamentoModal.idAtividadeApontamento} />
            </Dialog> : null}
            <BaseListagem ref={listagemRef} ordenacao="dataInicio,DESC" service={atividadeMeusApontamentosService} urlService="/" tituloPagina={'Meus apontamentos'}
                showNewButton={false}
                showEditButton={false}
                defaultFilters={defaultFilters} showClearFilterButton
                onChangeFilters={(filters) => setFilters(filters)}
                buttonsExtra={getButtonsExtra()}
                nome="atividadeMeusApontamentos"
            >
                <Column
                    field="dataInicio" header="Data Início"
                    body={(rowData) => converterDataHora(rowData.dataInicio)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column
                    field="dataFim" header="Data Fim"
                    body={(rowData) => converterDataHora(rowData.dataFim)}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={DateMatchModeOptions} filterApply={filterApplyTemplate}
                    filterElement={dateRangeFilterTemplate} filterMenuStyle={{ zIndex: 50 }}
                />
                <Column
                    field="atividade.nome" header="Atividade"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="atividade"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, atividades)}
                />
                <Column
                    field="pessoa.nome" header="Cliente"
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="pessoa"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, pessoas)}
                />
                <Column key="colOpcoes" style={{ whiteSpace: 'nowrap', width: '3em' }}
                    body={(item) => <Button type="button" icon={<FontAwesomeIcon icon="edit" />} className="ui-button-info" onClick={() => editarApontamento(item)}></Button>}
                />
            </BaseListagem >
        </>
    );
}